import logo from '../../assets/img/bmo-onguard-ida-logo-FR.svg';
import maintenanceLogo from '../../assets/img/logo-header-fr-ca.svg';
import { ROUTE_PATH_CONTACT, SHOW_MAINTENANCE_PAGE } from '../../constants';
import { SiteHeaderTranslations } from '../types';

export const translations: SiteHeaderTranslations = {
  logoImage: {
    src: SHOW_MAINTENANCE_PAGE() ? maintenanceLogo : logo,
    alt: SHOW_MAINTENANCE_PAGE() ? 'Logo du EnGarde' : 'Logo du EnGarde Fourni par assist identité',
    height: SHOW_MAINTENANCE_PAGE() ? 26 : 48,
    width: SHOW_MAINTENANCE_PAGE() ? 158 : 269
  },
  skipToMainContent: 'Sauter au contenu principal',
  skipToNavMenu: 'Sauter au menu de navigation',
  navMenu: {
    contact: {
      to: ROUTE_PATH_CONTACT,
      exact: true,
      children: 'Nous joindre'
    },
    languageToggle: {
      to: '',
      children: 'English'
    }
  }
};
